export default function OIBchecker(oib){    
    let value = oib.replace(/\D/g,'');    

    let calculated = 10;
    for (const digit of value.substring(0, 10)) {
        calculated += parseInt(digit);

        calculated %= 10;

        if (calculated === 0) {
            calculated = 10;
        }

        calculated *= 2;

        calculated %= 11;
    }
    let check = 11 - calculated;
    
    if (check === 10) {
        check = 0;
    }
    
    return check === parseInt(value[10])    
}
   